import React from 'react';
import Select from 'react-select';
import chroma from 'chroma-js';

import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

class ItemMultiSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: null
        };
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        if (prevProps.initialValue !== this.props.initialValue) {

            this.setState({
                items: this.props.initialValue
            })
        }
    }

    render() {
        const styles = !this.props.isColored ?
            {
                option: (provided) => ({
                    ...provided,
                    color: "#000"
                }),
                control: (provided) => ({
                    ...provided,
                    color: "#000"
                }),
            }
            : {
                control: styles => ({ ...styles, backgroundColor: 'white' }),
                option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                    const color = chroma(data.color);
                    return {
                        ...styles,
                        backgroundColor: isDisabled
                            ? null
                            : isSelected
                                ? data.color
                                : isFocused
                                    ? color.alpha(0.1).css()
                                    : null,
                        color: isDisabled
                            ? '#ccc'
                            : isSelected
                                ? chroma.contrast(color, 'white') > 2
                                    ? 'white'
                                    : 'black'
                                : data.color,
                        cursor: isDisabled ? 'not-allowed' : 'default',

                        ':active': {
                            ...styles[':active'],
                            backgroundColor: !isDisabled && (isSelected ? data.color : color.alpha(0.3).css()),
                        },
                    };
                },
                multiValue: (styles, { data }) => {
                    const color = chroma(data.color);
                    return {
                        ...styles,
                        backgroundColor: color.alpha(0.1).css(),
                    };
                },
                multiValueLabel: (styles, { data }) => ({
                    ...styles,
                    color: data.color,
                }),
                multiValueRemove: (styles, { data }) => ({
                    ...styles,
                    color: data.color,
                    ':hover': {
                        backgroundColor: data.color,
                        color: 'white',
                    },
                }),
            };

        return (
            <Select
                isMulti={this.props.isMulti}
                options={this.props.options}
                value={this.state.items}
                placeholder="Щёлкните для выбора..."
                isDisabled={this.props.isDisabled ? this.props.isDisabled : false}
                onChange={(value) => {

                    if (!value) {
                        this.setState({
                            items: []
                        },
                            this.props.onChange([])
                        );
                    }
                    else {
                        this.setState({
                            items: value
                        },
                            // this.props.onChange(value.map(item => { return item.value }))
                            this.props.onChange(value)
                        );
                    }
                }}
                styles={styles}
            />
        )
    }
}

export default ItemMultiSelector;